import Cookies from "js-cookie";
import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import { useLocation } from "react-router-dom";
import Header from "../components/layout/Header";
import { Helmet } from "react-helmet-async";

const LocalhostIframe = () => {
  const location = useLocation();
  const marketPath = location.pathname.replace(/^\/market/, "");
  const jwtToken = Cookies.get("access_token");
  // console.log("JWT Token from cookies:", jwtToken);
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        {/* <IonHeader mode="ios">
          <Header />
        </IonHeader> */}
        <IonContent>
          <div
            style={{
              width: "100%",
              height: "100vh",
              position: "relative",
            }}
          >
            <iframe
              // src="https://market.loonlog.ca"
              src={`https://market.loonlog.ca${marketPath}/sso?sso=${jwtToken}`}
              // src={`http://localhost:5173${marketPath}/sso?sso=${jwtToken}`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              title="Market"
            />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default LocalhostIframe;
